import React, {Component} from 'react';
import styles from './detailBonusStates.module.scss';
import Link from 'next/link';
import HiddenBonus from "./hiddenBonus";
import {getPreviousLocation, sendMetrics} from "../../../utils/misc";

export default class BonusesNeedAuthorization extends Component {
  render() {
    return (
      <div className={styles.BonusesNeedAuthorization}>
        <HiddenBonus/>
        <div className={styles.BonusesNeedAuthorizationShow}>
          <div className={styles.BonusesNeedAuthorizationShowImg}>
            <img src="/static/images/icons/bonusNeedAuth.svg" alt=""/>
          </div>
          <div className={styles.BonusesNeedAuthorizationShowTitle}>
            <span>Авторизуйтесь</span>
          </div>
          <div className={styles.BonusesNeedAuthorizationShowText}>
            <span>Чтобы взять бонус нужно войти в профиль и иметь подтверждённую донацию за последние 180 дней</span>
          </div>
          <div className={styles.BonusesNeedAuthorizationShowLogin}
               onClick={() => sendMetrics('to_login_from_bonus')}>
            <Link href={getPreviousLocation()}>
              <a>Вход на DonorSearch</a>
            </Link>
          </div>
        </div>
      </div>
    )
  }
}
